// 9fbef606107a605d69c0edbcd8029e5d

const swatchImgUrlFormation = (swatchImage, relatedSwatchImages = [], swatchId, imageId) => {
  let swatchUrl = swatchImage || '';
  if (swatchImage !== `${swatchId}_swatch.jpg`) {
    swatchUrl = relatedSwatchImages.find(
      (swatchImageUrl) => swatchImageUrl === `${swatchId}_swatch.jpg`
    );
  }
  let swatchImageName = swatchUrl || swatchId;
  swatchImageName =
    swatchImageName.indexOf('_swatch') === -1 ? `${swatchImageName}_swatch.jpg` : swatchImageName;
  return swatchImageName || imageId;
};
const specialCharReplacement = (content) => {
  const lowerCaseContent = content && content.toLowerCase();
  return lowerCaseContent && lowerCaseContent.replace(/\/|\s+/g, '_');
};

const getSwatchImgaeUrl = (
  isNewSwatchUrlEnabled,
  assetHost,
  swatchName,
  assetPath,
  mainpart,
  swatchImg,
  relatedSwatchImages,
  swatchId,
  activeId,
  isSwatchAsColorUrlUpdated,
) => {
  let imageUrl = '';
  const assetSwatchPath = 'ecom/assets/static/category/ecom_swatches';
  if (isSwatchAsColorUrlUpdated) {
    imageUrl = `${assetHost}/t_swatch_img,w_50,h_50,c_thumb,g_auto:0,f_auto,q_auto/${assetSwatchPath}/${swatchName}.jpg`;
  }
  
  else if (isNewSwatchUrlEnabled && swatchName) {
    imageUrl = `${assetHost}/d_ecom:assets:swatch:${swatchName}.jpg/t_swatch_img,w_50,h_50,c_thumb,g_auto:0,f_auto,q_auto/${assetPath}/${mainpart}/${swatchImgUrlFormation(
      swatchImg,
      relatedSwatchImages,
      swatchId,
      activeId
    )}`;
  } else {
    imageUrl = `${assetHost}/t_swatch_img,w_50,h_50,c_thumb,g_auto:0,f_auto,q_auto/${assetPath}/${mainpart}/${swatchImgUrlFormation(
      swatchImg,
      relatedSwatchImages,
      swatchId,
      activeId
    )}`;
  }
  return imageUrl;
};

const getColorSwatch = (
  swatches,
  activeId,
  assetHost,
  assetPath,
  swatchImg,
  relatedSwatchImages,
  tcpColor,
  auxDescription,
  isNewSwatchUrlEnabled,
  isSwatchAsColorUrlUpdated
) => {
  const swatchArray = swatches.split('|');
  const uniqueSwatchArray = [...new Set(swatchArray)];
  let activeSwatch = [];
  const inactiveSwatchArr = [];
  const tcpColorName = specialCharReplacement(auxDescription || tcpColor);
  if (!swatches.includes(activeId)) {
    activeSwatch = [
      {
        name: auxDescription || tcpColor,
        imageUrl:
          isNewSwatchUrlEnabled && (auxDescription || tcpColor)
            ? `${assetHost}/d_ecom:assets:swatch:${tcpColorName}.jpg/t_swatch_img,w_50,h_50,c_thumb,g_auto:0,f_auto,q_auto/${assetPath}/${
                activeId.split('_')[0]
              }/${activeId}_swatch.jpg`
            : `${assetHost}/t_swatch_img,w_50,h_50,c_thumb,g_auto:0,f_auto,q_auto/${assetPath}/${
                activeId.split('_')[0]
              }/${activeId}_swatch.jpg`,
        isActive: true,
        id: activeId,
      },
    ];
  }
  uniqueSwatchArray.forEach((swatch) => {
    const [swatchId = '', swatchName = ''] = swatch.split('#');
    const [mainpart = ''] = swatchId.split('_');
    if (activeId === swatchId) {
      activeSwatch = [
        {
          name: swatchName,
          imageUrl: getSwatchImgaeUrl(
            isNewSwatchUrlEnabled,
            assetHost,
            specialCharReplacement(swatchName),
            assetPath,
            mainpart,
            swatchImg,
            relatedSwatchImages,
            swatchId,
            activeId,
            isSwatchAsColorUrlUpdated
          ),
          isActive: activeId === swatchId,
          id: swatchId,
        },
      ];
    } else {
      inactiveSwatchArr.push({
        name: swatchName,
        imageUrl: getSwatchImgaeUrl(
          isNewSwatchUrlEnabled,
          assetHost,
          specialCharReplacement(swatchName),
          assetPath,
          mainpart,
          swatchImg,
          relatedSwatchImages,
          swatchId,
          activeId,
          isSwatchAsColorUrlUpdated
        ),
        isActive: activeId === swatchId,
        id: swatchId,
      });
    }
  });
  return [...activeSwatch, ...inactiveSwatchArr];
};

const getColorSwatchList = ({
  productPartNo,
  TCPSwatches,
  assetHost,
  assetPath,
  swatchImg,
  relatedSwatchImages,
  tcpColor,
  auxDescription,
  isNewSwatchUrlEnabled,
  productStyleType,
  isSwatchAsColorUrlEnabled
}) => {
  const isSwatchAsColorUrlUpdated = isSwatchAsColorUrlEnabled && productStyleType==='1' 
  return {
    colorSwatchList: TCPSwatches
      ? getColorSwatch(
          TCPSwatches,
          productPartNo,
          assetHost,
          assetPath,
          swatchImg,
          relatedSwatchImages,
          tcpColor,
          auxDescription,
          isNewSwatchUrlEnabled,
          isSwatchAsColorUrlUpdated
        )
      : [],
  };
};
export default getColorSwatchList;
